import showKnowledge from "./assets/scripts/ajax";
import searchSuggestions from "./assets/scripts/searchSuggestions";

jQuery(document).ready(function () {
    searchSuggestions();
})
